import "./component2.scss";
import React from "react";
import descImage_1 from "../../Images/descImages/descImage_1.jpg";
import descImage_2 from "../../Images/descImages/descImage_2.jpg";
import descImage_5 from "../../Images/descImages/descImage_5.jpg";
import descImage_6 from "../../Images/descImages/descImage_6.jpg";

const Component2 = () => {
  return (
    <section className="about component2" id="about">
      <div className="container">
        <p className="section-label about__label">О клубе</p>
        <h2 className="about__title">
          Пространство для игры, отдыха и вечеров без спешки
        </h2>
        <p className="about__lead">
          Пользуйтесь всеми удобствами и возможностями нашего заведения — от
          продуманной лаунж-зоны до бара с авторскими напитками.
        </p>

        <div className="about__grid">
          <article className="about-card">
            <div className="about-card__media">
              <img src={descImage_1} alt="" loading="lazy" />
            </div>
            <div className="about-card__body">
              <h3 className="about-card__title">14 столов</h3>
              <p className="about-card__text">
                9 столов для русского бильярда и 5 столов для американского пула
                — подберите формат под настроение компании.
              </p>
            </div>
          </article>

          <article className="about-card about-card--reverse">
            <div className="about-card__media">
              <img src={descImage_2} alt="" loading="lazy" />
            </div>
            <div className="about-card__body">
              <h3 className="about-card__title">Оборудование премиум-класса</h3>
              <p className="about-card__text">
                Столы и инвентарь высокого класса для русской пирамиды и пула —
                точная отдача и комфортная игра в каждой сессии.
              </p>
            </div>
          </article>

          <article className="about-card">
            <div className="about-card__media">
              <img src={descImage_5} alt="" loading="lazy" />
            </div>
            <div className="about-card__body">
              <h3 className="about-card__title">Бар и подача</h3>
              <p className="about-card__text">
                Барная карта и кухня для полноценного вечера — от лёгких закусок
                до сервированных блюд к столу.
              </p>
            </div>
          </article>

          <article className="about-card about-card--reverse">
            <div className="about-card__media">
              <img src={descImage_6} alt="" loading="lazy" />
            </div>
            <div className="about-card__body">
              <h3 className="about-card__title">Обучение и мастер-классы</h3>
              <p className="about-card__text">
                Индивидуальные занятия или мастер-классы для компаний — техника,
                правила и спортивная культура бильярда.
              </p>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
};

export default Component2;
